/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaddpicture3Inputs */

const en_aiflowaddpicture3 = /** @type {(inputs: Aiflowaddpicture3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a flyer or picture`)
};

const de_aiflowaddpicture3 = /** @type {(inputs: Aiflowaddpicture3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flyer oder Bild hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add a flyer or picture" |
*
* @param {Aiflowaddpicture3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaddpicture3 = /** @type {((inputs?: Aiflowaddpicture3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaddpicture3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaddpicture3(inputs)
	return de_aiflowaddpicture3(inputs)
});
export { aiflowaddpicture3 as "aiFlowAddPicture" }